import "./LoyaltyPoints.scss";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Form, FormInstance } from "antd";
import MainTitle from "../../components/ui/MainTitle/MainTitle";
import FormItemSwitch from "../../components/ui/FormItemSwitch/FormItemSwitch";
import FormItemInputNumber from "../../components/ui/FormItemInputNumber/FormItemInputNumber";
import FormItemSelect from "../../components/ui/FormItemSelect/FormItemSelect";
import FormItemCheckbox from "../../components/ui/FormItemCheckbox/FormItemCheckbox";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import exchangeArrowIcon from "../../assets/images/icons/arrows-exchange.svg";
import deleteIcon from "../../assets/images/icons/delete-orange.svg";
import plusBlackIcon from "../../assets/images/icons/plus-black.svg";
import euroGreyIcon from "../../assets/images/icons/euro-icon-grey.svg";
import useAppDispatch from "../../hooks/useAppDispatch";
import { openSuccessMessage } from "../../store/message/messageSlice";
import { useWatch } from "antd/es/form/Form";
import { ILoyaltySettingsUpdate } from "../../models/Loyalty";
import LoyaltyHistoryTable from "./LoyaltyHistoryTable/LoyaltyHistoryTable";
import { handleError } from "../../helper/errorHandler";
import { useGetLoyaltySettingsQuery } from "../../api/queries";
import { useLoyaltySettingsMutations } from "../../api/mutations";

const selectValues = [
  { id: "days", label: "Days" },
  { id: "months", label: "Months" },
  { id: "years", label: "Years" },
];

const LoyaltyPoints = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const formRef = useRef<FormInstance>(null);
  const dispatch = useAppDispatch();

  const enablePointsExpiration = useWatch("enablePointsExpiration", form);

  const { data: loyaltySettings } = useGetLoyaltySettingsQuery();
  const { updateLoyaltySettings } = useLoyaltySettingsMutations();

  useEffect(() => {
    if (loyaltySettings) {
      form.setFieldsValue({
        enablePointsExpiration: loyaltySettings.enablePointsExpiration,
        countExpiration: loyaltySettings.daysBeforePointsExpire,
        kindOfCountExpiration: selectValues[0].id,
        howMuchMoneyCustomerSpend: loyaltySettings.howMuchMoneyCustomerSpend,
        howManyPointsCustomerReceives: loyaltySettings.howManyPointsCustomerReceives,
        allowGetPointsFromAddons: loyaltySettings.allowGetPointsFromAddons,
        allowGetPointsFromSubscriptions: loyaltySettings.allowGetPointsFromSubscriptions,
      });
    }
  }, [loyaltySettings]);

  const onFinish = async (values: ILoyaltySettingsUpdate) => {
    let daysBeforePointsExpire = null;
    if (values.enablePointsExpiration && values.countExpiration) {
      switch (values.kindOfCountExpiration) {
        case "days":
          daysBeforePointsExpire = values.countExpiration;
          break;
        case "months":
          daysBeforePointsExpire = values.countExpiration * 30;
          break;
        case "years":
          daysBeforePointsExpire = values.countExpiration * 365;
          break;
        default:
          daysBeforePointsExpire = null;
      }
    }
    const model: ILoyaltySettingsUpdate = {
      enablePointsExpiration: !!values.enablePointsExpiration,
      daysBeforePointsExpire,
      howMuchMoneyCustomerSpend: values.howMuchMoneyCustomerSpend,
      howManyPointsCustomerReceives: values.howManyPointsCustomerReceives,
      allowGetPointsFromAddons: !!values.allowGetPointsFromAddons,
      allowGetPointsFromSubscriptions: !!values.allowGetPointsFromSubscriptions,
    };
    updateLoyaltySettings(
      {
        model,
      },
      {
        onSuccess: () => dispatch(openSuccessMessage(t("SettingsUpdatedSuccessfully"))),
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  return (
    <div className={"page-content loyalty-page"}>
      <MainTitle text={t("LoyaltyPoints")} />
      <Form
        form={form}
        className={"form"}
        ref={formRef}
        name="loyalty"
        onFinish={onFinish}
        autoComplete="off"
        layout={"vertical"}
      >
        <FormItemSwitch
          name={"enablePointsExpiration"}
          label={t("SetPointsExpiration")}
          rules={{ required: false }}
        />

        {!!enablePointsExpiration && (
          <>
            <p className={"text"}>{t("PointsWillExpireAfter")}</p>
            <div className={"expire-wrapper row"}>
              <div style={{ width: "30%" }}>
                <FormItemInputNumber
                  name={"countExpiration"}
                  label={""}
                  rules={{ required: true }}
                />
              </div>
              <div style={{ width: "70%" }}>
                <FormItemSelect
                  name={"kindOfCountExpiration"}
                  label={""}
                  rules={{ required: false }}
                  items={selectValues}
                />
              </div>
            </div>
          </>
        )}

        <LoyaltyHistoryTable />

        {/*<div className={"box"}>*/}
        {/*  <h3 className={"title"}>{t("Rewards")}</h3>*/}
        {/*  <Form.List name="exchangesForCustomer">*/}
        {/*    {(fields, { add, remove }) => {*/}
        {/*      return (*/}
        {/*        <>*/}
        {/*          {fields.map(({ key, name, ...restField }) => (*/}
        {/*            <div key={key} className={"row"}>*/}
        {/*              <FormItemInputNumber*/}
        {/*                name={[name, "numberOfPoints"]}*/}
        {/*                label={t("NumberOfPoints")}*/}
        {/*                rules={{ required: true }}*/}
        {/*              />*/}
        {/*              <div className={"exchange-icon-wrapper"}>*/}
        {/*                <img src={exchangeArrowIcon} alt={"Exchange"} />*/}
        {/*              </div>*/}
        {/*              <FormItemInputNumber*/}
        {/*                name={[name, "userReceive"]}*/}
        {/*                label={t("UserReceive")}*/}
        {/*                rules={{ required: true }}*/}
        {/*                prefix={euroGreyIcon}*/}
        {/*              />*/}
        {/*              {fields.length > 1 && (*/}
        {/*                <button*/}
        {/*                  className={"delete-icon-wrapper"}*/}
        {/*                  type="button"*/}
        {/*                  onClick={() => remove(name)}*/}
        {/*                >*/}
        {/*                  <img src={deleteIcon} alt={"delete"} />*/}
        {/*                </button>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*          ))}*/}

        {/*          <button className={"add-button"} type="button" onClick={() => add()}>*/}
        {/*            <img src={plusBlackIcon} alt={"Add"} />*/}
        {/*            {t("AddMore")}*/}
        {/*          </button>*/}
        {/*        </>*/}
        {/*      );*/}
        {/*    }}*/}
        {/*  </Form.List>*/}
        {/*</div>*/}

        <div className={"box"}>
          <h3 className={"title"}>{t("Points")}</h3>
          <div className={"row"}>
            <FormItemInputNumber
              name={"howMuchMoneyCustomerSpend"}
              label={t("ForHowManyUserSpends")}
              rules={{ required: true }}
              prefix={euroGreyIcon}
            />
            <FormItemInputNumber
              name={"howManyPointsCustomerReceives"}
              label={t("UserReceivesPoints")}
              rules={{ required: true }}
            />
          </div>
        </div>

        <h3 className={"ways-title"}>{t("SelectWaysUsersCanGetPointsWhenTheySpendMoney")}</h3>
        <div className={"row"}>
          <FormItemCheckbox
            name={"allowGetPointsFromAddons"}
            label={t("Addon")}
            rules={{ required: false }}
          />

          <FormItemCheckbox
            name={"allowGetPointsFromSubscriptions"}
            label={t("Subscription")}
            rules={{ required: false }}
          />
        </div>

        <div className={"save-btn-wrapper"}>
          <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
        </div>
      </Form>
    </div>
  );
};

export default LoyaltyPoints;
